import isEqual from 'lodash/isEqual';
import { client } from '../core/services/helpers';
import { AutoCompleteAddress, GetServicesInput, Pagination, Ride, Status } from '../core/apiTypes';

export const invalidateSearchAddressCache = (id = ''): void =>
    client.removeQueries(`geolocation-search-autocomplete${id}`);

export const getLatestSearchAddressCache = (text: string, id = ''): AutoCompleteAddress[] => {
    const queries = client.getQueriesData(`geolocation-search-autocomplete${id}`);
    const revertQueries = queries.filter((q) => q[1]).reverse();
    for (let i = 0; i < revertQueries.length; i++) {
        const query = revertQueries[i];
        if (text.includes((query[0][1] as any).address)) {
            return query[1] as AutoCompleteAddress[];
        }
    }
    return [];
};

export const getLatestRides = (awaiting: boolean): Pagination<Ride> => {
    const queries = client.getQueriesData('rides');
    const revertQueries = queries.filter((q) => q[1]).reverse();
    for (let i = 0; i < revertQueries.length; i++) {
        const query = revertQueries[i];
        if (((query[0][1] as any)?.status as string[]).includes(awaiting ? Status.CREATED : Status.ACCEPTED)) {
            return query[1] as Pagination<Ride>;
        }
    }
    return null;
};

export const getLatestRecurrentRides = (): Pagination<Ride> => {
    const queries = client.getQueriesData('searchCollabs${contractId}');
    const revertQueries = queries.filter((q) => q[1]).reverse();
    for (let i = 0; i < revertQueries.length; i++) {
        const query = revertQueries[i];
        return query[1] as Pagination<Ride>;
    }
    return null;
};

export const getLatestGuests = (contractId: string): Pagination<Ride> => {
    const queries = client.getQueriesData(`searchCollabs${contractId}`);
    const revertQueries = queries.filter((q) => q[1]).reverse();
    for (let i = 0; i < revertQueries.length; i++) {
        const query = revertQueries[i];
        return query[1] as Pagination<Ride>;
    }
    return null;
};

// return [query, answer]
export const getLatestQuote = (): any[] => {
    const queries = client.getQueriesData(`quotes`);
    const revertQueries = queries.filter((q) => q[1]).reverse();
    for (let i = 0; i < revertQueries.length; i++) {
        const query = revertQueries[i];
        return query;
    }
    return [];
};

export const invalidateQuotesCache = (): void => client.removeQueries(`quotes`);

export const needToReloadQuote = (prevPayload: GetServicesInput, newPayload: GetServicesInput): boolean => {
    return !isEqual(prevPayload, newPayload);
};
